import { modifyPickupSpecs } from '../api/pickupSpecs';

export const adoptPickupSpec = (id, data) => () => {
  return modifyPickupSpecs(id, data)
    .then(response => response.json());
};
